import * as React from 'react';

import cx from 'classnames';

import { GlyphName } from '@remind/r101-glyphs';
import Button from 'components/Button';
import Glyph from 'components/Glyph';
import Icon, { IconName } from 'components/Icon';
import MediaObject from 'components/MediaObject';

import './styles/AdminNoticeBanner.scss';

type Props = {
  actionElement?: React.ReactNode;
  children: any;
  color: 'sunrise' | 'shamrock' | 'lava' | 'brand' | 'koala';
  details?: any;
  glyph?: GlyphName;
  icon?: IconName;
  alwaysShowDetails?: boolean;
};

type State = {
  showDetails: boolean;
};

export default class AdminNoticeBanner extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      showDetails: props.alwaysShowDetails || false,
    };
  }

  handleShowDetails = () => {
    this.setState(prevState => ({ showDetails: !prevState.showDetails }));
  };

  renderGlyph = (body: React.ReactElement) => {
    const { icon, glyph } = this.props;

    if (icon) {
      return (
        <React.Fragment>
          <div className="AdminNoticeBanner-icon">
            <Icon name={icon} color="white" size="large" />
          </div>
          {body}
        </React.Fragment>
      );
    }

    if (glyph) {
      return (
        <React.Fragment>
          <div className="AdminNoticeBanner-icon">
            <Glyph name={glyph} color="white" size="xlarge" />
          </div>
          {body}
        </React.Fragment>
      );
    }

    return null;
  };

  renderBar = () => {
    const { children, glyph, icon } = this.props;

    const body = (
      <MediaObject center figure="right" className="AdminNoticeBanner-bar-body">
        <div className="AdminNoticeBanner-items">
          {React.Children.map(children, child => (
            <div className="AdminNoticeBanner-items-item">{child}</div>
          ))}
        </div>
        {this.renderButton()}
      </MediaObject>
    );

    return (
      <div className="AdminNoticeBanner-bar">
        {icon || glyph ? (
          this.renderGlyph(body)
        ) : (
          <div className="AdminNoticeBanner-bar--noGlyph">{body}</div>
        )}
      </div>
    );
  };

  renderButton = () => {
    const { actionElement, color, details, alwaysShowDetails } = this.props;
    const { showDetails } = this.state;

    return (
      (actionElement || details) && (
        <div>
          {details && !alwaysShowDetails ? (
            <Button color={color} level="secondary" onClick={this.handleShowDetails}>
              {showDetails ? 'Hide details' : 'Show details'}
            </Button>
          ) : (
            actionElement
          )}
        </div>
      )
    );
  };

  render() {
    const { color, details } = this.props;
    const { showDetails } = this.state;

    return (
      <div
        className={cx(
          'AdminNoticeBanner',
          `AdminNoticeBanner--${color}`,
          showDetails && 'AdminNoticeBanner--open'
        )}>
        {this.renderBar()}
        {showDetails && <div className="AdminNoticeBanner-drawer">{details}</div>}
      </div>
    );
  }
}
